import React from 'react';
import { makeStyles } from '@material-ui/core';

import { ReactComponent as Icon } from '#web-components/assets/icons/pause.svg';
import styles from './PauseIcon.styles';

const useStyles = makeStyles(styles, { name: 'PauseIcon' });

export default function PauseIcon() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Icon />
    </div>
  );
}
